import { refetchTopicAndQuestionDetails } from "@/lib/quizzes";
import { apiErrorToToast } from "@/lib/utils";
import {
  addEvidenceToQuizResponse,
  AddEvidenceToQuizResponseRequestParams,
} from "@/requests/questionnaries/add-evidence-to-quiz-response.request";
import { ApiErrorResponse } from "@/types/apis";
import { DimensionId } from "@/types/questionnaries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

type Params = AddEvidenceToQuizResponseRequestParams & {
  dimension: DimensionId;
  topic: string;
};

export const useAddEvidenceToQuizResponseMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Params) => addEvidenceToQuizResponse(variables),

    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },

    // Update the topic and the dimension when the answer is saved successfully
    onSuccess: (_, variables) => {
      refetchTopicAndQuestionDetails({
        queryClient,
        companyId: variables.companyId,
        quizId: variables.quizId,
        responseId: variables.responseId,
        dimension: variables.dimension as DimensionId,
        topic: variables.topic,
      });
    },
  });
};
